<template>
  <Modal
          :value="showModal"
          :title="
      adminForm._id
        ? 'Edit Administrator Account'
        : 'Add New Administrator Account'
    "
          :loading="loading"
          :closable="false"
          :mask-closable="false"
          @on-visible-change="onVisibleChange"
  >
    <Form ref="AdminForm" :model="adminForm" :rules="adminRules">
      <FormItem prop="Name">
        <i-input
                v-model="adminForm.Name"
                type="text"
                placeholder="Name"
        ></i-input>
      </FormItem>
      <FormItem prop="Email">
        <i-input
                v-model="adminForm.Email"
                type="email"
                placeholder="Email"
        ></i-input>
      </FormItem>
      <FormItem prop="Password">
        <i-input
                v-model="adminForm.Password"
                type="password"
                placeholder="Password"
        ></i-input>
        <p class="input-info">* should have at least: 20 characters | 2 uppercase | 2 lowercase | 2 digits | 2 special characters</p>
      </FormItem>
    </Form>
    <div slot="footer">
      <Button @click="handleCancel">Cancel</Button>
      <Button
              type="primary"
              :loading="submitLoading"
              style="margin-left: 8px"
              @click="handleCreateOrUpdate"
      >
        <span v-if="!submitLoading">{{
          adminForm._id ? "Update" : "Create"
        }}</span>
        <span v-else>Processing...</span>
      </Button>
    </div>
  </Modal>
</template>

<script>
  import {
    createAdministrator,
    updateAdministrator
  } from "../../_services/administrator.service";
  import {bus} from "../../main";

  const Joi = require('@hapi/joi');

  export default {
    props:['administrators'],
    data() {
      const validateEmail = (rule, value, callback) => {
        let duplicateEmail=this.administrators.filter(({Email})=>{
          return Email===value
        })
        if(duplicateEmail.length){
          callback(new Error('Mail address already in use.'));
        }else{
          callback();
        }

      };
      const validatePass = async (rule, value, callback) => {
        const schema = Joi.object({
          Password: Joi.string().regex(/^(?=.*[a-z].*[a-z])(?=.*[A-Z].*[A-Z])(?=.*\d.*\d)(?=.*\W.*\W)[a-zA-Z0-9\S]{20,}$/).required(),
        });

        try {
          await schema.validateAsync({ Password: value});
          callback();
        }
        catch (err) {
          callback(new Error('Invalid Password format.'));
        }
      };
      return {
        currentUserEmail: localStorage.getItem('user_email'),
        showModal: false,
        loading: false,
        title: "Add New Administrator",
        submitLoading: false,
        adminForm: {
          Name: "",
          Email: "",
          Password: ""
        },
        adminRules: {
          Email: [
            {
              required: true,
              message: "Please fill in the user email",
              trigger: "blur"
            },
            { validator: validateEmail, trigger: 'blur' }
          ],
          Password: [
            {
              required: true,
              message: "Please fill in the password",
              trigger: "blur"
            },
            { validator: validatePass, trigger: 'blur' }
          ],
        },
        adminData: {
          Name: "",
          Email: "",
          Password: ""
        },
        toUpdate: false
      };
    },
    methods: {
      triggerModal() {
        this.showModal = true;
      },
      triggerUpdateModal(administrator) {
        let vm = this;
        let cpAdmin = Object.assign({}, administrator);
        this.showModal = true;
        vm.adminForm = cpAdmin;
        vm.adminData = administrator;
        // delete this.adminRules.Password;
      },
      handleCreateOrUpdate() {
        this.$refs.AdminForm.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            if (this.adminForm._id) {
              if(JSON.stringify(this.adminForm)===JSON.stringify(this.adminData)){
                this.submitLoading = false;
                this.$Modal.info({
                  title: 'Nothing to update',
                  content: 'No changes has been made for the administrator',
                  okText: 'OK',
                });
              }else {
                updateAdministrator(this.adminForm._id, this.adminForm).then(res => {
                  this.showModal = false;
                  this.submitLoading = false;
                  let cpAdmin = Object.assign({}, res.data.data);
                  this.$emit('onSubmitResponse', 'update', cpAdmin)
                  if(this.adminData.Email===this.currentUserEmail){
                    localStorage.setItem('user_email',this.adminForm.Email)
                  }
                  this.$Message.success("Administrator account successfully updated!");
                }).catch(err => {
                  bus.$emit('requestError',err)
                  this.showModal = false;
                    this.submitLoading = false;
                    this.$Message.error(
                            "Failed to update Admin. Please try again later."
                    );

                });
              }
            } else {
              createAdministrator(this.adminForm).then(res => {
                this.showModal = false;
                this.submitLoading = false;
                this.$emit('onSubmitResponse')
                this.$Message.success(
                        "New administrator account successfully created!"
                );
              }).catch(err => {
                bus.$emit('requestError',err)
                this.showModal = false;
                  this.submitLoading = false;
                  if(err.response.data.status===403){
                    if(err.response.data.message==="email address already exists"){
                      this.$Message.error("Failed to create new Admin. Mail address already in use.");
                    }else {
                      this.$Message.error("Failed to create new Admin. Please try again later.");
                    }
                  }else {
                    this.$Message.error("Failed to create new Admin. Please try again later.");
                  }
              });
            }
          }
        });
      },
      handleCancel() {
        this.showModal = false;
        this.$refs.AdminForm.resetFields();
      },
      onVisibleChange(val) {
        if (!val) {
          this.adminForm = {
            Name: "",
            Email: "",
            Password: ""
          };
          this.$refs.AdminForm.resetFields();
        }
      }
    }
  };
</script>
